<template>
  <div id="app">
    <div :class="className">
      <div class="d-flex">
        <el-image :src="imgUrl" class="logoImg mr-1"></el-image>
        <router-link class="comName d-flex a-center" to="/">
          <el-image :src="imgText" class="imgText"></el-image>
        </router-link>
      </div>
      <div class="headerright" v-if="!mobile()">
        <router-link class="rightChild" to="/socialSummary"
          >会社概要</router-link
        >
        <router-link class="rightChild" to="/careerInformation"
          >事業・サービス</router-link
        >
        <router-link class="rightChild" to="/gatherInfo">募集情報</router-link>
        <router-link class="rightChild" to="/access">お問い合せ</router-link>
      </div>
      <el-dropdown v-if="mobile()">
        <div><i class="el-icon-s-operation"></i></div>
        <el-dropdown-menu slot="dropdown" class="dropdownBox">
          <el-dropdown-item
            ><router-link class="rightChild" to="/socialSummary"
              >会社概要</router-link
            ></el-dropdown-item
          >
          <el-dropdown-item
            ><router-link class="rightChild" to="/careerInformation"
              >事業・サービス</router-link
            ></el-dropdown-item
          >
          <el-dropdown-item
            ><router-link class="rightChild" to="/gatherInfo"
              >募集情報</router-link
            ></el-dropdown-item
          >
          <el-dropdown-item
            ><router-link class="rightChild" to="/access"
              >お問い合せ</router-link
            ></el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <router-view />
    <BottomFooter :class="footerClass"></BottomFooter>
  </div>
</template>

<script>
import BottomFooter from "@/components/BottomFooter.vue";
export default {
  components: {
    BottomFooter,
  },
  data() {
    return {
      imgText: require("./assets/logoText.png"),
      imgUrl: require("./assets/logomain.png"),
      className: "headerContain",
      footerClass: "",
    };
  },
  watch: {
    $route(to, from) {
      console.log(this.$route.name);
      if (this.$route.name === "policy") {
        this.className = "displayNo";
        this.footerClass = "displayNo";
      } else {
        this.className = "headerContain";
        this.footerClass = "footerContain";
      }
    },
  },
  created() {
    console.log('mobile',this.mobile());
  },
};
</script>

<style scoped>
.el-icon-s-operation:before {
  font-size: 28px;
}
.displayNo {
  display: none !important;
}
.router-link-active {
  text-decoration: none;
  color: #efaa97 !important;
}
.headerContain {
  position: fixed;
  top: 0px;
  background-color: #f8f8f8;
  border-color: #e7e7e7;
  display: flex;
  align-items: center;
  width: 100%;
  z-index: 10000;
  margin-bottom: 100px;
  box-sizing: border-box;
  padding: 0px 30px;
  justify-content: space-between;
}
.comName {
  width: 110px;
}
.headerright {
  display: flex;
  align-items: center;
}
.rightChild {
  padding: 10px 15px;
  color: #333;
  font-size: 12px;
  text-decoration: none;
}
.logoImg {
  width: 34px;
  padding: 3px 0px;
}
</style>

<style>
.dropdownBox {
  width: 100%;
  position: fixed;
  top: 44px;
  left: 0px !important;
  transform-origin: center top;
  z-index: 2001;
}
.el-dropdown-menu {
  background: rgba(255, 255, 255, 0.9); 
}
.dropdownBox li {
  color: #fff;
}
</style>
